import { contactMethods } from "@/content/trust";
import { site } from "@/content/site";
import { createMailto } from "@/lib/mailto";
import { ActionLink } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { List } from "@/components/ui/List";
import { PageHero } from "@/components/ui/PageHero";
import { Section } from "@/components/ui/Section";

const demoChecklist = [
  { label: "Brand or agency profile", description: "Markets, products, clients, and team roles" },
  {
    label: "Creative objective",
    description: "Launch, iteration, localization, or production scaling",
  },
  {
    label: "Current workflow",
    description: "Where briefs, assets, reviews, and approvals live today",
  },
  {
    label: "Governance needs",
    description: "Approval steps, permissions, and security requirements",
  },
];

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Talk with Agentic Plus"
        description="Tell us what you want to improve. A demo is most useful when we can start from your product facts, brand constraints, and a real creative decision."
      />

      <Section title="Ways to contact us" tone="surface">
        <div className="grid gap-6 md:grid-cols-3">
          {contactMethods.map((method) => (
            <Card key={method.title} title={method.title} description={method.description}>
              <ActionLink href={method.action.href} variant="secondary" className="mt-5 w-full">
                {method.action.label}
              </ActionLink>
            </Card>
          ))}
        </div>
      </Section>

      <Section
        title="Prepare for a demo"
        lead="You do not need a complete brief. These details help us show the parts of the product that matter to your team."
        tone="paper"
      >
        <div className="grid gap-8 lg:grid-cols-[1fr_.8fr]">
          <List items={demoChecklist} />
          <div className="surface-card p-7">
            <h3 className="text-2xl font-bold">Email directly</h3>
            <p className="mt-3 text-ink-soft">
              Send your objective and team type. We will reply with relevant next steps.
            </p>
            <ActionLink
              className="mt-5 w-full"
              href={createMailto(
                site.email,
                "Agentic Plus demo request",
                "Team type:\nObjective:\nMarkets:\nCurrent workflow:",
              )}
            >
              Start the email
            </ActionLink>
          </div>
        </div>
      </Section>
    </>
  );
}
